import ShUserAvatar from '@/components/Helpers/ShUserAvatar';

// @vue/component
export default {
  name: 'BehaviorAgentDirect',

  components: {
    ShUserAvatar,
  },

  props: {
    callBehaviorAgentId: {
      type: Number,
      required: true,
      default: null,
    },
    agentsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      agentId: this.callBehaviorAgentId,
    };
  },
};
